<template>
  <div class="container">
    <div class="form-group">
      <h2>Search and add a pin</h2>
      <label>
        <gmap-autocomplete
          @place_changed="setPlace">
        </gmap-autocomplete>
        <button @click="addMarker">Add</button>
      </label>
      <br/>
        <div v-if="markers.length > 0">
            <h4>{{markers}}</h4>
        </div>
        <div v-else>
            <h4>Your place lat long will be shown here.</h4>
        </div>
    </div>
    <br>
    <gmap-map
      :center="center"
      :zoom="12"
      style="width:100%;  height: 400px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>
    <div class="row h-50" v-show="this.markers.length > 0">
        <div class="form-group col my-4">
            <h2 class="message">To get walking directions to your destination, enter your 10 digit mobile number.</h2>
            <p>
                <label class="message" for="phone">Mobile Number</label>
                <input class="form-control"
                        id="phone"
                        v-model="phone"
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        type="tel"
                        name="phone">
            </p>
            <div class="py-3" style="text-align: center">
                <button class="ty-button" v-on:click="sendLink">Send link</button>
            </div>
        </div>
    </div>

    <div class="row h-50" v-show="linksReady">
        <div class="col my-4">
            <h4 class="message">You should have received links on your mobile device from the number provided.</h4>
            <h4 class="message">Also, you can click on one of the links below based on your phone to get directions.</h4>
            <div class="py-3" style="text-align: center">
                <a class="btn ty-button" :href="iosLink">iOS link</a>
            </div>
            <div class="py-3" style="text-align: center">
                <a class="btn ty-button" :href="androidLink">Android link</a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      errors: [],
      phone:null,
      iosLink:null,
      androidLink:null,
      linksReady:false
    };
  },

  mounted() {
    this.geolocate();
  },

  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    sendLink: function () {
        alert(`SMS sent to ${this.phone}`)
        const whereToLocation = this.markers[0]
        // console.log("where to: ", whereToLocation)
        const encodedAddress = encodeURI(`${whereToLocation.position.lat},${whereToLocation.position.lng}`)
        this.iosLink = "maps://maps.google.com/maps/?q=" + encodedAddress
        this.androidLink = "https://maps.google.com/?q=" + encodedAddress
        const lastMileAPI = 'https://oa-poi-helper.herokuapp.com/last-mile'
        //const lastMileAPI = 'http://localhost:3000/last-mile'
        this.axios.post(lastMileAPI ,{
          headers: {
            'Content-Type':'application/json'
          },
          data:{
            iosLink:this.iosLink,
            androidLink:this.androidLink,
            toNumber:'+1'+this.phone
          }
        }).then((response) => {
          // eslint-disable-next-line no-console
          console.log("message: ", response)
        }).catch((e) => {
          // eslint-disable-next-line no-console
          console.log("error: ", e)
        })
        this.linksReady = true
      }
  }
};
</script>
<style scoped>
a:link {
        color:#FFFFFF;
}
.btn {
    color:#FFFFFF;
}
.ty-button{
    background: #4281ff;
    /*border-radius: 22px;*/
    width:343px;
    height:64px;
    /*font-family: Helvetica;*/
    font-family: ToyotaType-Semibold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.73px;
    text-align: center;
}
</style>
